<!--====================================
=            CARD TABLE TAB            =
=====================================-->

<template>
    <v-row>
        <v-col cols="12" md="12" sm="12">
            <v-tabs v-model="tab" center class="transparent"  :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'" small>
                <v-tabs-slider></v-tabs-slider>

                <v-tab href="#tab-1" :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'" >
                    Position

                </v-tab>

                <v-tab href="#tab-2" :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'" >
                    Ordens
                </v-tab>

                <v-tab href="#tab-3" :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'" >
                    Closed
                </v-tab>
                <v-tab href="#tab-4" :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'" >
                    Exchanges
                </v-tab>
               
            </v-tabs>
            <v-tabs-items class="transparent" v-model="tab">
                <v-tab-item class="transparent" value="tab-1">
                   
                            <v-data-table  :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'" :headers="headers" :items="desserts" class="elevation-1 ">
                                <template v-slot:item.price="{ item }">
                                    <v-chip :color="getColor(item.price)" dark>
                                        {{ item.price }}
                                    </v-chip>
                                </template>
                            </v-data-table>
                        
                </v-tab-item>
                <v-tab-item class="transparent" value="tab-2">
               
                            <v-data-table   :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'" :headers="headers" :items="ordens"  class="elevation-1">
                                <template v-slot:item.price="{ item }">
                                    <v-chip :color="getColor(item.price)" dark>
                                        {{ item.price }}
                                    </v-chip>
                                </template>
                            </v-data-table>
                       
                </v-tab-item>
                <v-tab-item value="tab-3">
                   
                            <v-list  :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'" dense two-line>
                                <v-list-item-group v-model="selected" active-class="amber--text" multiple>
                                    <template v-for="(item, index) in items">
                                        <v-list-item :key="item.title">
                                            <template v-slot:default="{ active }">
                                                <v-avatar :color="item.color" class="pa-2 ma-2" size="36">
                                                    <span class="white--text text-h5">{{item.letra}}</span>
                                                </v-avatar>
                                                <v-list-item-content>
                                                    <v-list-item-title v-text="item.title"></v-list-item-title>



                                                    <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle>
                                                </v-list-item-content>

                                                <v-list-item-action>
                                                    <v-list-item-action-text v-text="item.action">
                                                    </v-list-item-action-text>

                                                    <v-icon v-if="!active" color="grey lighten-1">
                                                        {{item.icon}}
                                                    </v-icon>

                                                    <v-icon v-else color="amber darken-3">
                                                        {{item.icon}}
                                                    </v-icon>
                                                </v-list-item-action>
                                            </template>
                                        </v-list-item>

                                        <v-divider v-if="index < items.length - 1" :key="index"></v-divider>
                                    </template>
                                </v-list-item-group>
                            </v-list>
                      
                </v-tab-item>
                <v-tab-item value="tab-4">
                   
                            <v-data-table  :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'" :headers="headers" :items="desserts" class="elevation-1">
                                <template v-slot:item.price="{ item }">
                                    <v-chip :color="getColor(item.price)" dark>
                                        {{ item.price }}
                                    </v-chip>
                                </template>
                            </v-data-table>
                       
                </v-tab-item>
              
            </v-tabs-items>
        </v-col>
    </v-row>


</template>
<script>
    export default {
        data() {
            return {
                tab: null,
                headers: [{
                        text: 'Name',
                        align: 'start',
                        sortable: false,
                        value: 'name',
                    },
                    {
                        text: 'Price',
                        value: 'price'
                    },
                    {
                        text: 'Type',
                        value: 'type'
                    },
                    {
                        text: 'Total',
                        value: 'total'
                    },
                    {
                        text: 'Volume ',
                        value: 'volume'
                    },
                    {
                        text: 'Change (%)',
                        value: 'change'
                    },
                ],
                desserts: [{
                        name: 'ZIL',
                        price: 1.5954,
                        type: 'LONG',
                        total: 24,
                        volume: 4.0,
                        change: '1%',
                    },
                    {
                        name: 'BNB',
                        price: 1.5954,
                        type: 'LONG',
                        total: 24,
                        volume: 4.0,
                        change: '1%',
                    },
                    {
                        name: 'LTC',
                        price: 1.5954,
                        type: 'LONG',
                        total: 24,
                        volume: 4.0,
                        change: '1%',
                    },
                    {
                        name: 'CREAM',
                        price: -5954,
                        type: 'LONG',
                        total: 24,
                        volume: 4.0,
                        change: '1%',
                    },
                    {
                        name: 'META',
                        price: 1.5954,
                        type: 'LONG',
                        total: 24,
                        volume: 4.0,
                        change: '1%',
                    },

                ],
                ordens: [{
                    name: 'ETH',
                    price: 1.5954,
                    type: 'LONG',
                    total: 24,
                    volume: 4.0,
                    change: '1%',
                }, {
                    name: 'BAT',
                    price: -1.5954,
                    type: 'LONG',
                    total: 24,
                    volume: 4.0,
                    change: '1%',
                }, {
                    name: 'BTC',
                    price: 1.5954,
                    type: 'LONG',
                    total: 24,
                    volume: 4.0,
                    change: '1%',
                }, {
                    name: 'LTO',
                    price: 1.5954,
                    type: 'LONG',
                    total: 24,
                    volume: 4.0,
                    change: '1%',
                }, {
                    name: 'LINA',
                    price: -1.5954,
                    type: 'LONG',
                    total: 24,
                    volume: 4.0,
                    change: '1%',
                }, ],
                selected: [2],
                items: [{
                        color: 'green',
                        letra: 'J',
                        action: '15 %',

                        subtitle: `$10.64`,
                        title: 'JUV | USDT',
                        icon: 'south'
                    },

                    {
                        color: 'green',
                        letra: 'A',
                        action: '12 %',
                        icon: 'north',
                        subtitle: '$10.13',
                        title: 'ATM|USDT'
                    },
                    {
                        color: 'red',
                        letra: 'C',
                        action: '-18%',
                        icon: 'south',
                        subtitle: '$43.2',
                        title: 'CREAM|USDT',
                    },
                ],
            }
        },
        methods: {
            getColor(price) {
                if (price > 0) return 'green'
                else if (price < 0) return 'red'
                else return 'green'
            },
        },
    }
</script>
<style>
  .card-light {
    border-radius: 1em;
    border: 1px solid rgba(255, 255, 255, 0.5);
    text-shadow: 0 0 1em rgba(0, 0, 0, 0.5);
    background: rgba(255, 255, 255, 0.2);
    -webkit-backdrop-filter: blur(20px);
    backdrop-filter: blur(20px);
    transform: perspective(500px);
    transform-style: preserve-3d;
  }  .card-dark {
    border-radius: 1em;
    border: 1px solid rgba(0, 0, 0, 0.5);
    text-shadow: 0 0 1em rgba(245, 245, 245, 0.5);
    background: rgba(0, 0, 0, 0.2);
    -webkit-backdrop-filter: blur(20px);
    backdrop-filter: blur(20px);
    transform: perspective(500px);
    transform-style: preserve-3d;
  }
</style>

<!--====  End of CARD TABLE TAB  ====-->
